import type { FilaJukebox, MusicaAtualBroadcast } from '../entities/FilaJukebox';

/**
 * Segundos até o primeiro pedido da sessão começar a tocar.
 *
 * Resta da faixa no ar + soma das pendentes à frente. Qualquer duração
 * ausente (atual ou à frente) → `null` — a UI fica só na posição.
 * Pedido da sessão já `tocando` → `null`.
 */
export function calcularEtaFilaSegundos(
  filaAtiva: readonly FilaJukebox[],
  sessionId: string,
  musicaAtual: Pick<MusicaAtualBroadcast, 'duracao_segundos' | 'iniciada_em'> | null,
  agoraMs: number,
): number | null {
  if (!sessionId) return null;
  if (filaAtiva.some(f => f.session_id === sessionId && f.status === 'tocando')) {
    return null;
  }

  const pendentes = filaAtiva.filter(f => f.status === 'pendente');
  const meuIdx = pendentes.findIndex(f => f.session_id === sessionId);
  if (meuIdx < 0) return null;

  const restanteAtual = restanteMusicaAtualSegundos(musicaAtual, agoraMs);
  if (restanteAtual === null) return null;

  let somaFrente = 0;
  for (let i = 0; i < meuIdx; i++) {
    const duracao = pendentes[i].duracao_segundos;
    if (duracao == null || duracao <= 0) return null;
    somaFrente += duracao;
  }

  return restanteAtual + somaFrente;
}

export function formatarEtaMinutos(segundos: number): string {
  const min = Math.max(1, Math.ceil(segundos / 60));
  return `~${min} min`;
}

function restanteMusicaAtualSegundos(
  musicaAtual: Pick<MusicaAtualBroadcast, 'duracao_segundos' | 'iniciada_em'> | null,
  agoraMs: number,
): number | null {
  const duracao = musicaAtual?.duracao_segundos;
  const iniciadaEm = musicaAtual?.iniciada_em;
  if (duracao == null || duracao <= 0 || !iniciadaEm) return null;
  const inicio = new Date(iniciadaEm).getTime();
  if (Number.isNaN(inicio)) return null;
  return Math.max(0, duracao - (agoraMs - inicio) / 1000);
}
